import React, { useMemo } from "react";
import { MaterialReactTable } from "material-react-table";

import {
  pvEstimationTableProps,
  useResponsivePvEstimationColumns,
  withPvEstimationStyles,
} from "./pvEstimationTableStyles";
import { Box } from "@mui/material";

const BOM_COLUMN_WEIGHTS = {
  itemNo: 0.75,
  materialDescription: 2.8,
  qty: 0.75,
  dimension: 1.15,
  unit: 0.75,
  weightLb: 1,
};
const bomColumns = [
  {
    accessorKey: "itemNo",
    header: "Item No",
    size: 80,
    grow: 0.8,
    enableSorting: false,
  },

  {
    accessorKey: "materialDescription",
    header: "Material Description",
    size: 300,
    grow: 3,
    enableSorting: false,
  },

  {
    accessorKey: "qty",
    header: "Qty",
    size: 80,
    grow: 0.8,
    enableSorting: false,
  },

  {
    accessorKey: "dimension",
    header: "Dimension",
    size: 150,
    grow: 1.5,
    enableSorting: false,
  },

  {
    accessorKey: "unit",
    header: "Unit",
    size: 80,
    grow: 0.8,
    enableSorting: false,
  },

  {
    accessorKey: "weightLb",
    header: "Weight (lb)",
    size: 110,
    grow: 1.1,
    enableSorting: false,
  },
];

export default function BomTable({ data, dimensionWidth = 150 }) {
  const columns = useMemo(
    () =>
      withPvEstimationStyles(
        bomColumns.map((column) =>
          column.accessorKey === "dimension"
            ? {
                ...column,
                size: dimensionWidth,
              }
            : column,
        ),
      ),
    [dimensionWidth],
  );

  const { viewportRef, tableWidth, responsiveColumns, columnSizing } =
    useResponsivePvEstimationColumns({
      columns,
      columnWeights: BOM_COLUMN_WEIGHTS,
    });

  return (
    <Box
      ref={viewportRef}
      sx={{
        width: "100%",
        minWidth: 0,
        maxWidth: "100%",

        overflowX: "hidden",
      }}
    >
      <MaterialReactTable
        {...pvEstimationTableProps}
        columns={responsiveColumns}
        data={data || []}
        layoutMode="grid-no-grow"
        enableColumnResizing={false}
        defaultColumn={{
          size: 1,
          minSize: 1,
          maxSize: 100000,
          grow: false,
        }}
        state={{
          columnSizing,
        }}
        enableSorting={false}
        enableColumnActions={false}
        enableTopToolbar={false}
        enableBottomToolbar={false}
        muiTableProps={{
          sx: {
            width: `${tableWidth}px !important`,

            minWidth: `${tableWidth}px !important`,

            maxWidth: `${tableWidth}px !important`,
          },
        }}
      />
    </Box>
  );
}
